import connector from 'api/http';

import config from 'shared/config';
import {
  unmarshalMaintenanceBanner,
  WireConfigResponse,
  unmarshalMaintenanceType,
  unmarshalMaintenanceProducts,
} from 'scenes/common/api/config';
import { Dispatch } from 'redux';
import { updateConfig } from '../redux/config/configActions';
import { ReduxAction } from '../redux/config/configReducer';

export const handleConfigResponse = (
  response: WireConfigResponse
): ReduxAction =>
  updateConfig({
    underMaintenance: unmarshalMaintenanceBanner(response.items),
    ccMaintenance: unmarshalMaintenanceType(response.items),
    productsUnderMaintenance: unmarshalMaintenanceProducts(response.items),
  });

export const handleNoConfigResponse = (): ReduxAction =>
  updateConfig({ underMaintenance: false });

const getConfigData = (
  dispatch: Dispatch,
  baseUrl: string = config.baseUrls.BFF_BASE_URL
) => {
  const server = connector(baseUrl);

  const onConfigResponse = (response: WireConfigResponse) =>
    dispatch(handleConfigResponse(response));

  const onConfigError = () => dispatch(handleNoConfigResponse());

  server.get('/referencedata/system/config').then(onConfigResponse).catch(
    // Set config to empty
    onConfigError
  );
};

export default getConfigData;
